module.exports = __webpack_public_path__ + "static/img/02042D_5_6_C_20240426_LC.4c32710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02042D_5_6_C_20240426_LC.png
// module id = AO1q
// module chunks = 0